
<!-- Toolbar -->
<mat-toolbar>
  <mat-toolbar-row>
    <img width="40" alt="Angular Logo" src="assets/favicon.png" />
    <span>Corona Virus- India</span>
    <span class="flexExpand"></span>
    <a aria-label="Medium" target="_blank" style="color:white; margin-top: 5px; font-size: 9pt; text-decoration: none;"
      rel="noopener" href="https://kvkirthy.github.io/showcase" title="Medium">
      Web
    </a>
    &nbsp;
    &nbsp;
    <a aria-label="Angular on twitter" target="_blank" rel="noopener" href="https://twitter.com/keertikotaru"
      title="Twitter">
      <svg id="twitter-logo" height="24" data-name="Logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
        <rect width="400" height="400" fill="none" />
        <path
          d="M153.62,301.59c94.34,0,145.94-78.16,145.94-145.94,0-2.22,0-4.43-.15-6.63A104.36,104.36,0,0,0,325,122.47a102.38,102.38,0,0,1-29.46,8.07,51.47,51.47,0,0,0,22.55-28.37,102.79,102.79,0,0,1-32.57,12.45,51.34,51.34,0,0,0-87.41,46.78A145.62,145.62,0,0,1,92.4,107.81a51.33,51.33,0,0,0,15.88,68.47A50.91,50.91,0,0,1,85,169.86c0,.21,0,.43,0,.65a51.31,51.31,0,0,0,41.15,50.28,51.21,51.21,0,0,1-23.16.88,51.35,51.35,0,0,0,47.92,35.62,102.92,102.92,0,0,1-63.7,22A104.41,104.41,0,0,1,75,278.55a145.21,145.21,0,0,0,78.62,23"
          fill="#fff" />
      </svg>
    </a>
    &nbsp;
    &nbsp;
    <a aria-label="Medium" target="_blank" rel="noopener" href="https://keertikotaru.medium.com/" title="Medium">
      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
        <rect width="80%" height="75%" fill="white" />
        <path
          d="M19 24h-14c-2.761 0-5-2.239-5-5v-14c0-2.761 2.239-5 5-5h14c2.762 0 5 2.239 5 5v14c0 2.761-2.237 4.999-5 5zm.97-5.649v-.269l-1.247-1.224c-.11-.084-.165-.222-.142-.359v-8.998c-.023-.137.032-.275.142-.359l1.277-1.224v-.269h-4.422l-3.152 7.863-3.586-7.863h-4.638v.269l1.494 1.799c.146.133.221.327.201.523v7.072c.044.255-.037.516-.216.702l-1.681 2.038v.269h4.766v-.269l-1.681-2.038c-.181-.186-.266-.445-.232-.702v-6.116l4.183 9.125h.486l3.593-9.125v7.273c0 .194 0 .232-.127.359l-1.292 1.254v.269h6.274z" />
      </svg>
    </a>
    &nbsp;
    &nbsp;
  </mat-toolbar-row>
</mat-toolbar>

<div class="content" role="main">
  <router-outlet></router-outlet>
</div>
